/*!
 * Name: DCC
 * Author: Zengenti Ltd
 * Description: DCC JS
 * Version: 0.2.2
 */

var app = (function($) {
  'use strict';

  // private alias to settings
  var s;

  return {
    settings: function() {
      this.$window = $(window);
      this.$menuToggle = $('.js-menu-toggle');
      this.$searchToggle = $('.js-search-toggle');
      this.$topTasksToggle = $('.js-toptasks-toggle');
    },

    init: function() {
      s = new this.settings();

      this.mainMenu();
      this.mobileMenu();
      this.searchToggle();
      this.topTasksToggle();
      this.imageGallery();
      this.cookieBar();
      this.googleMap();

      this.bindUIActions(); // UI Actions (click, focus etc)
      this.bindWindowActions(); // Window actions (scrolling, resize etc)
    },

    mainMenu: function() {

      var $menuNav = $('.nav');
      // Toggle Menu icon
      s.$menuToggle.on('click', function(e) {
        e.preventDefault();
        if ($(window).width() < 641) {
          $('.sys_search-query-control').stop(true, true).slideUp(400);
          $('.svg .svg-search-icon').show();
          $('.svg .svg-close-icon').hide();
        }

        $(this).toggleClass('js-menu-open');
        $('.header__menu-toggle').toggleClass('open');
        $('.no-svg .header__menu--cross--fallback').toggle();

        // Slidetoggle menu navigation
        $menuNav.stop(true, true).slideToggle(600);
        $menuNav.find('li.nav__item a').eq(0).focus();

      });

      // $menuNav.find('li.nav__item a').eq(8).on('blur', function() {
      //   $menuNav.stop(true, true).slideUp(600);
      // });

    },

    mobileMenu: function() {
      // prevent default clicking on direct children of .cd-primary-nav
      $('.nav ul').children('.has-children').children('a').on('click', function() {
        //event.preventDefault();
      });
      // open submenu
      $('.has-children').children('a').on('click', function() {
        //event.preventDefault();
        var selected = $(this);
        if (selected.next('ul').hasClass('is-hidden')) {
          // lets do this
          selected.addClass('selected').next('ul').removeClass('is-hidden').end().parent('.has-children').parent('ul').addClass('moves-out');
          selected.parent('.has-children').siblings('.has-children').children('ul').addClass('is-hidden').end().children('a').removeClass('selected');
        } else {
          selected.removeClass('selected').next('ul').addClass('is-hidden').end().parent('.has-children').parent('ul').removeClass('moves-out');
        }
      });

      // submenu items - go back link
      $('.go-back').on('click', function() {
        $(this).parent('ul').addClass('is-hidden').parent('.has-children').parent('ul').removeClass('moves-out');
      });

    },

    searchToggle: function() {

      var $searchInput = $('.sys_search-query-control');
      // Toggle Search icon
      s.$searchToggle.on('click', function(e) {
        e.preventDefault();
        $('.nav').stop(true, true).slideUp(600);
        $('.header__menu-toggle').removeClass('open');
        $('.no-svg .header__menu--cross--fallback').hide();
        $(this).toggleClass('js-search-open');
        $('.svg .svg-search-icon').toggle();
        $('.svg .svg-close-icon').toggle();

        // Slidetoggle search input
        $searchInput.stop(true, true).slideToggle(400).css('display', 'inline-block');

        // Must be a better way of doing this

        $(window).on('load, resize', function() {
          var mediaQuery = window.matchMedia('(min-width: 641px)');
          //var viewportWidth = $(window).width();
          // if (viewportWidth < 641) {
          if (mediaQuery) {
            $('.sys_search-query-control').css('display', 'inline-block');
            $('.svg .svg-search-icon').hide();
            $('.svg .svg-close-icon').show();
          }
        });

      });

    },

    topTasksToggle: function() {

      // Toggle more top tasks
      s.$topTasksToggle.on('click', function(e) {
        e.preventDefault();
        if (!$('.top-task__wrapper--more').is(':visible')) {

          $('.top-task__wrapper--more').slideDown(500);
          $('.top-task__wrapper--more .column').animate({
            opacity: 1
          }, {
            queue: false,
            duration: '800'
          });
        } else {

          $('.top-task__wrapper--more').slideUp(500);
          $('.top-task__wrapper--more .column').animate({
            opacity: 0
          }, {
            queue: false,
            duration: '800'
          });
        }

        $('.js-toptasks-toggle--less').toggleClass('inline-block');
        $('.js-toptasks-toggle--more').toggleClass('hidden');
        $('.js-toptasks-toggle--less .icon').toggleClass('inline-block');
        $('.js-toptasks-toggle--more .icon').toggleClass('hidden');

      });

    },

    imageGallery: function() {

      //var $indicator = $('.slide-indicator');
      var $slickElement = $('.slider-for');

      $slickElement.on('init reInit afterChange', function(event, slick, currentSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;


        $('.slide-indicator').remove();
        $slickElement.append('<div class="slide-indicator"> ' + i + ' of ' + slick.slideCount + ' </div>');
      });

      // Slick slider parameters
      $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        nextArrow: '<button type="button" class="slick-next"><span class="visuallyhidden">next arrow</span><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-chevron-right-white"><use xlink:href="#icon-chevron-right-white"></use></svg></button>',
        prevArrow: '<button type="button" class="slick-prev"><span class="visuallyhidden">previous arrow</span><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-chevron-left-white"><use xlink:href="#icon-chevron-left-white"></use></svg></button>',
        fade: true,
        asNavFor: '.slider-nav',
        autoplay: false,
        dots: false,
        adaptiveHeight: true,
        adaptiveWidth: true
      });
      $('.slider-nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        nextArrow: '<button type="button" class="slick-next"><span class="visuallyhidden">next arrow</span><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-chevron-right-purple"><use xlink:href="#icon-chevron-right-purple"></use></svg></button>',
        prevArrow: '<button type="button" class="slick-prev"><span class="visuallyhidden">previous arrow</span><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-chevron-left-purple"><use xlink:href="#icon-chevron-left-purple"></use></svg></button>',
        asNavFor: '.slider-for',
        dots: false,
        centerMode: true,
        focusOnSelect: true,
        adaptiveHeight: true,
        adaptiveWidth: true

      });

    },

    cookieBar: function() {

      $.cookieBar({
        message: 'We use cookies to provide you with a better service. Carry on browsing if you\'re happy with this, or find out how to manage <a href="">cookies</a>.',
        acceptButton: true,
        acceptText: '<span class="visuallyhidden">close cookie bar</span><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-cookie-close"><use xlink:href="#icon-cookie-close"></use></svg>',
        acceptFunction: null,
        declineButton: false,
        declineText: 'Disable Cookies',
        declineFunction: null,
        policyButton: false,
        policyText: 'Privacy Policy',
        policyURL: '/privacy-policy/',
        autoEnable: true,
        acceptOnContinue: false,
        acceptOnScroll: false,
        acceptAnyClick: false,
        expireDays: 365,
        renewOnVisit: false,
        forceShow: true,
        effect: 'slide',
        element: 'footer',
        append: true,
        fixed: true,
        bottom: true,
        zindex: '',
        domain: 'www.example.com',
        referrer: 'www.example.com'
      });

    },

    googleMap: function() {
  // if HTML DOM Element that contains the map is found...
  if (document.getElementById('map-canvas')) {

    //   For Contensis
    // var map = $('#map-canvas'),
    // lat = map.data('lat'),
    // lng = map.data('lng'),
    // pin = map.data('pin')

    //  var myLatlng = new google.maps.LatLng(lat,lng)

    // For Local
    var myLatlng = new google.maps.LatLng(53.3021114, -1.4730221);

    // Other options for the map, pretty much selfexplanatory
    var mapOptions = {
      zoom: 12,
      center: myLatlng,
      scrollwheel: false,
      draggable: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,

      styles: [
        {
          'featureType': 'water',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '$purple-light'
            }, {
              'lightness': 17
            }
          ]
        }, {
          'featureType': 'landscape',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '$purple-light'
            }, {
              'lightness': 20
            }
          ]
        }, {
          'featureType': 'road.highway',
          'elementType': 'geometry.fill',
          'stylers': [
            {
              'color': '#ffffff'
            }, {
              'lightness': 17
            }
          ]
        }, {
          'featureType': 'road.highway',
          'elementType': 'geometry.stroke',
          'stylers': [
            {
              'color': '$purple-light'
            }, {
              'lightness': 29
            }, {
              'weight': 0.2
            }
          ]
        }, {
          'featureType': 'road.arterial',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '$purple-light'
            }, {
              'lightness': 18
            }
          ]
        }, {
          'featureType': 'road.local',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '$purple-light'
            }, {
              'lightness': 16
            }
          ]
        }, {
          'featureType': 'poi',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#f5f5f5'
            }, {
              'lightness': 21
            }
          ]
        }, {
          'featureType': 'poi.park',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '$purple-light'
            }, {
              'lightness': 21
            }
          ]
        }, {
          'elementType': 'labels.text.stroke',
          'stylers': [
            {
              'visibility': 'on'
            }, {
              'color': '#ffffff'
            }, {
              'lightness': 16
            }
          ]
        }, {
          'elementType': 'labels.text.fill',
          'stylers': [
            {
              'saturation': 36
            }, {
              'color': '$purple'
            }, {
              'lightness': 10
            }
          ]
        }, {
          'elementType': 'labels.icon',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        }, {
          'featureType': 'transit',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#f2f2f2'
            }, {
              'lightness': 19
            }
          ]
        }, {
          'featureType': 'administrative',
          'elementType': 'geometry.fill',
          'stylers': [
            {
              'color': '#fefefe'
            }, {
              'lightness': 20
            }
          ]
        }, {
          'featureType': 'administrative',
          'elementType': 'geometry.stroke',
          'stylers': [
            {
              'color': '#fefefe'
            }, {
              'lightness': 17
            }, {
              'weight': 1.2
            }
          ]
        }
      ]
    };

    // Marker

    var marker = new google.maps.Marker({

      map: mmap,
      //icon: 'http://projects.zengenti.com/andy-temp-nm343gdc/uni/images/mapPin.png',
      //icon: pin,
      position: myLatlng,
      visible: true
    });

    // Attach a map to the DOM Element, with the defined settings
    var mmap = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);
    marker.setMap(mmap);
  }

},


    bindUIActions: function() {



      $('.alert-bar__close').on('click', function() {
        //e.stopPropagation();
        $(this).parent().parent().slideUp(500);
      });
      $('.cookie-bar__close').on('click', function(event) {
        event.preventDefault();
        $(this).parent().parent().slideUp(500);
      });


    },

    bindWindowActions: function() {

      // Smooth scroll EVERYTHING

      // Select all links with hashes
      $('a[href*="#"]')
      // Remove links that don't actually link to anything
        .not('[href="#"]').not('[href="#0"]').click(function(event) {
        // On-page links
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length
            ? target
            : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top
            }, 1000, function() {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(':focus')) {
                // Checking if the target was focused
                return false;
              } else {
                $target.attr('tabindex', '-1');
                // Adding tabindex for elements not focusable
                $target.focus();
                // Set focus again
              }
            });
          }
        }
      });
    }

  };
})(jQuery);

jQuery(document).ready(function() {
  app.init();

});
